// Auto-generated section component extracted from Landing.jsx
import React from "react";

export default function OutreachSection({ api }) {
  const { t } = api || {};
  return (
<section id="outreach" className="space-y-4">
                <h2 className="text-2xl sm:text-3xl font-semibold text-emerald-300">
                  {t.outreach.heading}
                </h2>
                <div className="rounded-3xl border border-slate-800/70 bg-[#010916]/85 p-6">
                  <p className="text-sm sm:text-base text-slate-200 max-w-4xl">
                    {t.outreach.body}
                  </p>
                </div>
              </section>
  );
}
